<p-confirmDialog [style]="{ width: '450px' }" />

<div class="container-fluid appointment-page">
  <app-work-context-bar />

  <div class="appointment-shell">
    <section class="appointment-toolbar">
      <div class="toolbar-top">
        <div class="toolbar-title">
          <h5 class="mb-0">Appointments</h5>
          <small>{{ filteredAppointments.length }} record(s)</small>
        </div>
        <button type="button" class="btn add-btn" (click)="startAdd()">
          <i class="pi pi-plus me-1"></i>
          Add Appointment
        </button>
      </div>

      <div class="toolbar-controls">
        <div class="search-wrap">
          <i class="pi pi-search"></i>
          <input
            type="text"
            class="form-control"
            placeholder="Search patient, doctor, clinic..."
            [(ngModel)]="searchTerm"
            (ngModelChange)="onFiltersChanged()"
          />
        </div>

        <select
          class="form-select status-filter"
          [(ngModel)]="statusFilter"
          (ngModelChange)="currentPage = 1; onFiltersChanged()"
        >
          <option value="all">All Statuses</option>
          <option *ngFor="let s of status" [value]="s.value">{{ s.label }}</option>
        </select>

        <select
          class="form-select status-filter"
          [(ngModel)]="flowFilter"
          (ngModelChange)="currentPage = 1; onFiltersChanged()"
        >
          <option *ngFor="let f of flowFilterOptions" [value]="f.value">{{ f.label }}</option>
        </select>

        <input
          type="date"
          class="form-control date-filter"
          [(ngModel)]="dateFilter"
          (ngModelChange)="currentPage = 1; onFiltersChanged()"
        />

        <button type="button" class="btn btn-outline-secondary reset-btn" (click)="clearFilters(); onFiltersChanged()">
          <i class="pi pi-filter-slash me-1"></i>
          Reset
        </button>
      </div>
    </section>

    <section class="appointment-table-card">
      <div class="table-responsive">
        <table class="table modern-table mb-0">
          <thead>
            <tr>
              <th>Patient</th>
              <th>Date</th>
              <th>Time</th>
              <th>Clinic</th>
              <th>Doctor</th>
              <th>Flow</th>
              <th>Status</th>
              <th class="action-cell">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of paginatedAppointments">
              <td>
                <div class="patient-cell">
                  <span class="patient-avatar">{{ getPatientInitial(item.patient_name) }}</span>
                  <span class="patient-name">{{ item.patient_name || '—' }}</span>
                </div>
              </td>
              <td>
                <span class="date-pill">{{ item.appointment_date || '—' }}</span>
              </td>
              <td>{{ to12Hour(item.start_time) }}</td>
              <td>{{ item.clinic_name || '—' }}</td>
              <td>{{ item.doctor_name || '—' }}</td>
              <td>
                <div class="flow-chip-wrap">
                  <span class="flow-chip" [ngClass]="getFlowClass(item)">{{ getFlowLabel(item) }}</span>
                </div>
              </td>
              <td>
                <span class="status-chip" [ngClass]="getStatusClass(item.status)">
                  {{ item.status_label || formatStatusLabel(item.status) }}
                </span>
              </td>
              <td class="action-cell">
                <button type="button" class="table-action-btn edit-btn" (click)="startEdit(item)" title="Edit appointment">
                  <i class="pi pi-pencil"></i>
                </button>
              </td>
            </tr>
            <tr *ngIf="paginatedAppointments.length === 0">
              <td colspan="8" class="text-center py-4 empty-state">
                <i class="pi pi-inbox d-block mb-2"></i>
                No appointments found.
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="table-pagination" *ngIf="filteredAppointments.length > 0">
        <div class="pagination-info">
          Showing {{ paginatedAppointments.length }} of {{ filteredAppointments.length }}
        </div>
        <div class="pagination-controls">
          <select class="form-select form-select-sm" style="width: auto" [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange()">
            <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }} / page</option>
          </select>
          <button type="button" class="page-btn" [disabled]="currentPage <= 1" (click)="goToPreviousPage()">
            <i class="pi pi-chevron-left"></i>
          </button>
          <button
            type="button"
            class="page-btn"
            *ngFor="let page of visiblePageNumbers"
            [class.active]="page === currentPage"
            (click)="goToPage(page)"
          >
            {{ page }}
          </button>
          <button type="button" class="page-btn" [disabled]="currentPage >= totalPages" (click)="goToNextPage()">
            <i class="pi pi-chevron-right"></i>
          </button>
        </div>
      </div>
    </section>
  </div>
</div>

<p-dialog
  [header]="appointment.id ? 'Edit Appointment' : 'Add Appointment'"
  [(visible)]="showForm"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '70vw', maxWidth: '1450px' }"
  [breakpoints]="{ '1200px': '95vw', '768px': '100vw' }"
  styleClass="appointment-dialog"
  [contentStyle]="{ 'max-height': '72vh', overflow: 'auto', padding: '14px 16px 10px' }"
  (onHide)="closeForm()"
>
  <form class="appointment-dialog-form" #appointmentForm="ngForm">
    <div class="row g-2 appt-form-row">
      <div class="col-md-6">
        <label for="patient_name" class="form-label">Patient <span class="text-danger">*</span></label>
        <p-autoComplete
          inputId="patient_name"
          name="patient_name"
          [(ngModel)]="selectedPatient"
          [suggestions]="patientSuggestions"
          (completeMethod)="searchPatients($event)"
          (onSelect)="onPatientSelect($event)"
          field="full_name"
          placeholder="Search by name, number, or contact"
          [forceSelection]="true"
          emptyMessage="No patients found"
          appendTo="body"
          styleClass="w-100 appt-compact-control"
          [inputStyle]="{ width: '100%' }"
        ></p-autoComplete>
      </div>

      <div class="col-md-3">
        <label for="clinic" class="form-label">Clinic <span class="text-danger">*</span></label>
        <p-dropdown
          inputId="clinic"
          name="clinic"
          [options]="clinicList"
          [(ngModel)]="appointment.clinic_id"
          optionLabel="label"
          optionValue="value"
          placeholder="Select Clinic"
          appendTo="body"
          (onChange)="onClinicChange()"
          styleClass="w-100 appt-compact-control"
        ></p-dropdown>
      </div>

      <div class="col-md-3">
        <label for="doctor" class="form-label">Doctor <span class="text-danger">*</span></label>
        <p-dropdown
          inputId="doctor"
          name="doctor"
          [options]="doctorsList"
          [(ngModel)]="appointment.doctor_id"
          optionLabel="label"
          optionValue="value"
          placeholder="Select Doctor"
          appendTo="body"
          styleClass="w-100 appt-compact-control"
        ></p-dropdown>
      </div>
    </div>

    <div class="row g-2 appt-form-row">
      <div class="col-md-3">
        <label for="status" class="form-label">Status</label>
        <p-dropdown
          inputId="status"
          name="status"
          [options]="status"
          [(ngModel)]="appointment.status"
          optionLabel="label"
          optionValue="value"
          placeholder="Select Status"
          appendTo="body"
          styleClass="w-100 appt-compact-control"
        ></p-dropdown>
      </div>

      <div class="col-md-3">
        <label for="appointment_date" class="form-label">Appointment Date <span class="text-danger">*</span></label>
        <input
          type="date"
          class="form-control appt-compact-input"
          id="appointment_date"
          name="appointment_date"
          (change)="generateTimeSlots()"
          [(ngModel)]="appointment.appointment_date"
        />
      </div>

      <div class="col-md-6">
        <label class="form-label">Delivery</label>
        <div class="appt-flow-badge-group">
          <button
            type="button"
            class="dispense-flow-badge dispense-flow-badge--medicine"
            [class.is-active]="appointment.medicine_collection"
            (click)="setMedicineCollection(!appointment.medicine_collection)"
          >
            <i class="pi pi-box" aria-hidden="true"></i>
            Medicine
          </button>
          <button
            *ngFor="let option of deliveryTypeOptions"
            type="button"
            class="dispense-flow-badge"
            [ngClass]="'dispense-flow-badge--' + option.value"
            [class.is-active]="isDeliveryTypeActive(option.value)"
            (click)="setDeliveryType(option.value)"
          >
            <i class="pi" [ngClass]="option.icon" aria-hidden="true"></i>
            {{ option.label }}
          </button>
        </div>
      </div>
    </div>

    <div class="appt-time-slots">
      <div class="appt-time-label">
        <i class="pi pi-clock"></i>
        <span class="appt-compact-label mb-0">Select Time Slot <span class="text-danger">*</span></span>
      </div>
      <p class="slot-schedule-note" *ngIf="appointment.appointment_date">{{ slotScheduleNote }}</p>
      <div class="row g-2">
        <div class="col-12" *ngIf="timeSlots.length === 0">
          <div class="slot-empty-note">No appointment slots available for this clinic on the selected date.</div>
        </div>
        <div class="col-6 col-md-3" *ngFor="let slot of timeSlots">
          <button
            name="time_slot"
            type="button"
            class="slot-btn w-100"
            [class.selected]="selectedSlot === slot"
            [disabled]="slot.disabled"
            (click)="selectSlot(slot)"
          >
            {{ slot.label }}
          </button>
        </div>
      </div>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <div class="dialog-footer-actions">
      <button type="button" class="btn btn-light border" (click)="closeForm()">Cancel</button>
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="appointmentForm.invalid || isSubmitting || !selectedPatient || !selectedSlot"
        (click)="processAppointments()"
      >
        <i class="pi pi-check me-1"></i>
        {{ appointment.id ? 'Update' : 'Add' }} Appointment
      </button>
    </div>
  </ng-template>
</p-dialog>
